import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosInstance, AxiosResponse } from "axios"
import { IPropsCreateServiceProvider, IResponseCreateServiceProvider } from "./types"
import { useApi } from "../../useApi"
import { CreateServiceProviderUrl } from "../../../utils/constants"
import { Dispatch, SetStateAction, useContext } from "react"
import { ToastMessageContext } from "@context/toast-message-cotnext"
import { useTranslation } from "react-i18next"
async function postCreateServiceProvider(
	responseData: IPropsCreateServiceProvider,
	apiPrivate: AxiosInstance,
	showError: Dispatch<SetStateAction<string | undefined>>,
	language: string
): Promise<AxiosResponse<IResponseCreateServiceProvider>> {
	try {
		const response: AxiosResponse<IResponseCreateServiceProvider> =
			await apiPrivate.post(`${CreateServiceProviderUrl}`, { ...responseData })

		return response
	} catch (error: any) {
		showError(
			error.response?.data?.errorMessages
				.map((item: any) =>
					language === "ar" ? item.messageAr : item.messageEn
				)
				.join(", ")
		)
		return error
	}
}

export function usePostCreateServiceProvider(
	options?:
		| Omit<
				UseMutationOptions<
					AxiosResponse<IResponseCreateServiceProvider>,
					unknown,
					unknown,
					AxiosResponse<IResponseCreateServiceProvider>
				>,
				"mutationFn"
		  >
		| undefined
) {
	const { showError, showSuccess } = useContext(ToastMessageContext)
	const {
		i18n: { language },
	} = useTranslation()
	const { apiPrivate } = useApi()
	const mutation = useMutation({
		mutationFn: (data: IPropsCreateServiceProvider) =>
			postCreateServiceProvider(data, apiPrivate, showError, language),
		...options,
	})
	return mutation
}
